<div class="reg_container">
    <div class="Page_container">
        <div class="reg_content">
            <div class="title_content">
                <h2>Protección de datos</h2>
            </div>
            <div class="columns">
                <div class="forms_container">
                    <div class="termsUse">
                        <h3>1.- ¿Quién es el responsable del tratamiento de sus datos?</h3>
                        <table border="1" cellpadding="8" cellspacing="0" class="table">
                            <tbody>
                                <tr>
                                    <th>Identidad</th>
                                    <td>UNION FINANCIERA ASTURIANA S.A. EFC. A-33053984</td>
                                </tr>
                                <tr>
                                    <th>Dirección</th>
                                    <td>C/ Pelayo, 15 (entrada pasaje) – 33003 Oviedo</td>
                                </tr>
                                <tr>
                                    <th>Web/Teléfono</th>
                                    <td><a href="http://www.confia.es"
                                            target="_blank">www.confia.es</a> / 900 838 026 (Gratuito)</td>
                                </tr>
                                <tr>
                                    <th>Email</th>
                                    <td><a
                                            href="mailto:protecciondedatos@confia.es">protecciondedatos&#64;confia&#46;es</a>
                                    </td>
                                </tr>
                                <tr>
                                    <th>Contacto Delegado de Protección de Datos</th>
                                    <td><a
                                            href="mailto:protecciondedatos@confia.es">protecciondedatos&#64;confia&#46;es</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <h3>2.- ¿Cuales son las finalidades del tratamiento de sus datos?</h3>
                        <h4>Finalidades principales</h4>
                        <h4>Valorar y decidir sobre su solicitud de préstamo/crédito, ejecución del contrato y
                            elaboración de perfiles.</h4>
                        <p class="sep-paragraph">
                            Unión Financiera Asturiana tratará datos personales indispensables para la valoración del
                            riesgo y para la gestión del contrato, incluso realizando operaciones que permitan obtener
                            un perfil crediticio, en particular mediante la utilización de sistemas automatizados para
                            la toma de decisiones crediticias (scoring). Asimismo, se consultará información relativa a
                            sus antecedentes crediticios incluidos en ficheros de solvencia en patrimonial. Además, sus
                            datos serán tratados durante la relación contractual para evaluar su solvencia con el fin de
                            ofrecerle ampliaciones y disposiciones de línea de crédito consultando para ello fuentes
                            externas, en particular, ficheros de solvencia patrimonial.
                        </p>

                        <h4>Finalidades relacionadas con la publicidad o la mercadotecnia</h4>
                        <h4>Envío de publicidad y ofertas comerciales propias.</h4>

                        <p class="sep-paragraph">
                            Los datos de contacto serán tratados para el envío de comunicaciones comerciales de Unión
                            Financiera Asturiana por cualquier medio, incluído el correo electrónico, SMS, MMS, fax o
                            llamadas automatizadas.
                        </p>
                        <h4>Envío de información y ofertas comerciales de terceras empresas del Grupo del mismo sector
                            (financiero- seguros).</h4>
                        <p class="sep-paragraph">
                            Los datos identificativos de contacto podrán ser tratados para el envío de comunicaciones de
                            Unión Financiera Asturiana por cualquier medio, incluído el correo electrónico, SMS, MMS,
                            fax o llamadas automatizadas.
                        </p>
                        <h4>Envío de publicidad de terceras empresas.</h4>
                        <p class="sep-paragraph">
                            Los datos identificativos de contacto podrán ser tratados para el envío de información y
                            ofertas comerciales de empresas de los siguientes sectores de actividad: financiero,
                            seguros, telecomunicaciones, ocio, gran consumo, automoción, formación, energía y agua y
                            ONG.
                            Asímismo Unión Financiera Asturiana tratará sus datos con el fin de remitirle promociones
                            especiales de terceras empresas a través del espacio web o cualquier otro canal habilitado
                            por Unión Financiera Asturiana a tal efecto.
                            En caso de que el contrato no llegue a formalizarse, Unión Financiera Asturiana conservará
                            sus datos personales y los tratará mientras usted no ejerza ninguno de los derechos que
                            hagan que no podamos conservar sus datos, con el fin de ofrecerle productos similares que
                            puedan ser de su interés.
                            Unión Financiera Asturiana consultará las oportunas listas de exclusión publicitaria para
                            evitar envíos de publicidad no deseada.
                        </p>
                        <h4>Finalidades relacionadas con una obligación legal</h4>
                        <h4>Cumplimiento de políticas de préstamo responsable y prevención del Fraude.</h4>
                        <p class="sep-paragraph">
                            En aplicación de políticas obligatorias de préstamo responsable, Unión Financiera Asturiana
                            comunicará sus datos y los relativos a su crédito a la Central de Información de Riesgos del
                            Banco de España. <br>
                            En caso de impago, los datos relativos a su deuda serán comunicados a ficheros de solvencia
                            patrimonial.<br>
                            En relación a la prevención del Fraude, Unión Financiera Asturiana comunicará sus datos al
                            Fichero de gestión de fraude Confirma.
                        </p>
                        <h4>Prevención del blanqueo de capitales y financiación del terrorismo.</h4>
                        <p class="sep-paragraph">
                            Unión Financiera Asturiana realizará las actuaciones de verificación de los datos aportados
                            por los solicitantes que considere oportunas para la prevención del blanqueo de capitales,
                            en particular Unión Financiera Asturiana comunicará sus datos al servicio de verificación de
                            datos con consentimiento (VEDACON).
                            Unión Financiera Asturiana está obligada a comunicar al Servicio Ejecutivo de Prevención del
                            Blanqueo de Capitales (SEPBLAC) cualquier hecho u operación respecto de los cuales exista
                            indicio o certeza de que está relacionado con el blanqueo de capitales o financiación del
                            terrorismo.
                        </p>
                        <h4>
                            Plazo de conservación
                        </h4>
                        <p class="sep-paragraph">
                            Los datos personales proporcionados se conservarán y tratarán mientras se mantenga la
                            relación contractual. Una vez finalizada, los mismos permanecerán bloqueados, durante el
                            tiempo de prescripción de las posibles responsabilidades nacidas del tratamiento, de acuerdo
                            a lo establecido en el art. 32 de la LOPD-GDD, y demás normativa que le es de aplicación al
                            contrato celebrado.
                        </p>
                        <p class="sep-paragraph">
                            En caso de que el contrato no llegue a formalizarse, Unión Financiera Asturiana conservará
                            sus datos personales y los tratará, con el fin de ofrecerle productos similares que puedan
                            ser de su interés, si ha prestado su consentimiento para acciones de marketing propio y de
                            terceros, tal como se ha indicado en el apartado anterior.
                        </p>
                        <h3>3.- ¿Cuál es la legitimación para el tratamiento de sus datos?</h3>
                        <h4>Ejecución del contrato. Art. 6b) del RGPD.</h4>
                        <h4>Consentimiento. Art. 6a) del RGPD.</h4>
                        <p class="sep-paragraph">
                            Para los tratamientos previos a la concesión del préstamo/crédito, así como para el envío de
                            publicidad de empresas del Grupo y de terceras empresas que completen la actividad de Unión
                            Financiera Asturiana.
                        </p>
                        <h4>Cumplimiento de obligaciones legales. Art. 6c) del RGPD.</h4>
                        <p class="sep-paragraph">
                            En materia de prevención de blanqueo de capitales y prevención del Fraude ( Real
                            Decreto304/2014 por el que se aprueba el Reglamento de la Ley 10/2010 de prevención del
                            blanqueo de capitales y de la financiación del terrorismo), así como en materia de préstamos
                            responsables en cuanto a scoring y consulta de ficheros de solvencia ( Ley 16/2011, de 24 de
                            junio de contratos de crédito al consumo).
                        </p>
                        <h4>Interés légitimo</h4>
                        <p class="sep-paragraph">
                            Aquellas medidas necesarias para la satisfacción total de la obligación contraída con Unión
                            Financiera Asturiana.
                        </p>
                        <h3>4.- ¿Quiénes podrán ser destinatarios de la comunicación de datos?
                            Destinatarios</h3>
                        <p class="sep-paragraph">
                            Central de Información de Riesgos del Banco de España (CIRBE).
                            Sistemas de Información Crediticia (art. 20 de la LOPD-GDD).
                            Prestadores de servicio que actúan como encargados de tratamiento de datos.
                            Terceras personas del Grupo del mismo sector (financiero-seguros).
                            Terceras empresas de los sectores anteriormente indicados que complementen la oferta de
                            servicios de Unión Financiera Asturiana.

                        </p>
                        <h3>5.- ¿Cuáles son sus derechos cuando nos facilita sus datos?</h3>
                        <h4>Acceso/rectificación y supresión </h4>
                        <p class="sep-paragraph">
                            Las personas interesadas tienen derecho a acceder a sus datos personales, así como a
                            solicitar la rectificación de los datos inexactos o, en su caso, solicitar su supresión
                            cuando, entre otros motivos, los datos ya no sean necesarios para la ejecución del contrato.
                        </p>
                        <h4>Limitación </h4>
                        <p class="sep-paragraph">
                            En determinadas circunstancias, los interesados podrán solicitar la limitación del
                            tratamiento de sus datos ante el responsable del tratamiento, cuando se de alguna de las
                            situaciones reflejadas en el art. 18 del RGPD..
                        </p>
                        <h4>Oposición</h4>
                        <p class="sep-paragraph">
                            Los interesados podrán oponerse al tratamiento de sus datos. Unión Financiera Asturiana S.A
                            EFC dejará de tratar los datos, salvo por motivos legítimos, imperiosos o el ejercicio o
                            defensa de posibles reclamaciones, y los mantendremos debídamente bloqueados durante el
                            plazo correspondiente mientras persistan las obligaciones legales.
                            Igualmente el interesado tiene derecho a oponerse a la adopción de decisiones individuales
                            automatizadas que pudieran producir efectos jurídicos o afectarle significativamente. <br>

                            Los interesados podrán oponerse al envío de publicidad por parte de Unión Financiera
                            Asturiana, tanto publicidad directa de Unión Financiera Asturiana S.A EFC como de las
                            empresas del Grupo o de terceras empresas.
                            En caso de ejercer el derecho de oposición de envío de publicidad, sus datos serán incluídos
                            en un listado de exclusión publicitaria que tiene por objetivo disminuir la publicidad que
                            recibe. <br>
                        </p>
                        <h4>Portabilidad</h4>
                        <p class="sep-paragraph">
                            Las personas interesadas pueden solicitar recibir los datos que le incumban y que nos haya
                            facilitado o solicitar que se los enviemos a otro responsable del tratamiento de su
                            elección, en un formato estructurado de uso común y lectura mecánica. <br>

                            Así mismo, el interesado tiene derecho a retirar en cualquier momento el consentimiento
                            prestado, sin que ello afecte a la licitud del tratamiento basado en el consentimiento
                            prestado en el momento de la suscripción del contrato.<br>

                            Si desea ejercer alguno de los derechos expuestos, rogamos que nos remita carta con todos
                            sus datos, incluyendo DNI a Unión Financiera Asturiana S.A EFC, C/ Pelayo, 15 (entrada
                            pasaje), 33003 Oviedo, llame al nº teléfono 900 838 026 o nos envíe un e-mail a
                            protecciondedatos&#64;confia.es. Le informamos del derecho que le asiste a presentar
                            reclamación ante la Autoridad de Control (AEPD).
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer-landing></app-footer-landing>